import { render, staticRenderFns } from "./EsgDataUpload.vue?vue&type=template&id=bd3179bc&scoped=true"
import script from "./EsgDataUpload.vue?vue&type=script&lang=js"
export * from "./EsgDataUpload.vue?vue&type=script&lang=js"
import style0 from "./EsgDataUpload.vue?vue&type=style&index=0&id=bd3179bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3179bc",
  null
  
)

export default component.exports